import React from 'react';
import Helpers from '~/utils/Helpers';
import classNames from 'classnames';
type CSFilterBoxProps = {
  isEnd: boolean;
  onFilterChange: (...args: any[]) => any;
  filterField?: string;
  value: string;
  placeholder: string;
  tabIndex: React.ReactNode;
};
class CSFilterBox extends React.Component<CSFilterBoxProps, {}> {
  UNSAFE_componentWillMount() {
    this.actuallyChange = Helpers.debounce(this.actuallyChange, 500);
  }
  actuallyChange = () => {
    const { filterField, onFilterChange } = this.props;
    let newSearchFilter = {};
    newSearchFilter[filterField] = this.filterTextInput.value;
    onFilterChange(newSearchFilter);
  };
  resetSearch = () => {
    this.props.onFilterChange({ query: '' });
  };
  render() {
    const { placeholder, tabIndex, value } = this.props;
    const xCls = classNames({
      sci: true,
      sci__close: true,
      'pr--': true,
      'cursor-on-hover--pointer': true,
      invisible: value.length === 0,
    });
    return (
      <div className="flex flex--align-items--stretch position--relative">
        <input
          type="text"
          placeholder={placeholder}
          tabIndex={tabIndex}
          ref={c => (this.filterTextInput = c)}
          className="flex flex-grow--1 searchbox font--h7 pr+"
          id="search-input"
          onChange={this.actuallyChange}
        />

        <div className="position--absolute top--10 right--10">
          <i className={xCls} onClick={this.resetSearch} />
        </div>
      </div>
    );
  }
}
export default CSFilterBox;
